import { GrupoPermissaoAttributes } from "@fl/shared/src/types/models/suporte_fl/permissoes";
import { UsuarioAttributes } from "@fl/shared/src/types/models/suporte_fl/usuarios";
import { useEffect, useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import ApiPermissions from "../../../services/suporte/auth/permissions";
import SortFunctions from "../../../utils/sortArrays";
import "./styles.css";

interface IProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedGroup: GrupoPermissaoAttributes | null;
  onUpdateUsersPermissions: (updated_users: UsuarioAttributes[]) => void;
}

const ModalPermissionsUsersMenus: React.FC<IProps> = ({
  showModal,
  setShowModal,
  selectedGroup,
  onUpdateUsersPermissions,
}) => {
  const [hasChanges, setHasChanges] = useState(false);
  const [users, setUsers] = useState<UsuarioAttributes[]>([]);
  const [updatedUsers, setUpdatedUsers] = useState<UsuarioAttributes[]>([]);

  useEffect(() => {
    if (showModal) {
      const loadUsers = async () => {
        const result = await new ApiPermissions().listUsers();
        if (result.success) setUsers(result.data);
      };

      loadUsers();
    }
  }, [showModal]);

  const renderItems = (data: UsuarioAttributes[], editable?: boolean) => {
    const elements = data.map((item) => {
      return (
        <li
          key={item.id_usuario!.toString()}
          onDoubleClick={() => {
            if (editable) onUpdateUser(item);
          }}
        >
          <div
            className={`d-flex justify-content-between users-item ${editable ? "users-item-editable" : "users-item-not-editable"}`}
          >
            <div>{item.nome}</div>
            <div className="mx-3">
              {item.GrupoPermissao ? item.GrupoPermissao.nome : ""}
            </div>
          </div>
        </li>
      );
    });

    return <ul>{elements}</ul>;
  };

  const onUpdateUser = (item: UsuarioAttributes) => {
    if (selectedGroup) {
      const newData = [...users];
      const index = newData.findIndex(
        (user) => user.id_usuario === item.id_usuario
      );
      newData[index].id_grupo_permissao = selectedGroup.id_grupo_permissao!;
      setUpdatedUsers([...updatedUsers, newData[index]]);
      setUsers(newData);
      setHasChanges(true);
    }
  };

  const onClose = () => {
    setShowModal(false);
    setHasChanges(false);
    setUsers([]);
    setUpdatedUsers([]);
  };

  const onSave = () => {
    onUpdateUsersPermissions(updatedUsers);
    onClose();
  };

  return (
    <Modal
      show={showModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onClose}
    >
      {selectedGroup && (
        <>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Grupo de Permissões '{selectedGroup.nome}' - Usuários
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Container fluid>
              <Row>
                <Col>
                  Usuários (Geral)
                  <div className="users-container">
                    {renderItems(
                      users
                        .sort((a, b) =>
                          new SortFunctions(a.nome, b.nome).sortStrAsc()
                        )
                        .filter(
                          (i) =>
                            i.id_grupo_permissao !==
                            selectedGroup.id_grupo_permissao!
                        ),
                      true
                    )}
                  </div>
                </Col>
                <Col>
                  Usuários em Grupo de Permissões '{selectedGroup.nome}'
                  <div className="users-container">
                    {renderItems(
                      users
                        .sort((a, b) =>
                          new SortFunctions(a.nome, b.nome).sortStrAsc()
                        )
                        .filter(
                          (i) =>
                            i.id_grupo_permissao ===
                            selectedGroup.id_grupo_permissao!
                        )
                    )}
                  </div>
                </Col>
              </Row>
            </Container>

            <div className="mx-3 my-1">
              <small>
                Para transferir o usuário para o Grupo de Permissão atual, dê um{" "}
                <b>
                  <u>duplo clique</u>
                </b>{" "}
                no mesmo.
              </small>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-between"
            >
              <Button variant="outline-danger" type="submit" onClick={onClose}>
                Fechar
              </Button>

              <Button
                disabled={!hasChanges}
                variant="outline-success"
                type="submit"
                onClick={onSave}
              >
                Salvar
              </Button>
            </div>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default ModalPermissionsUsersMenus;
